import {
  methodAllowsRequestBody,
  prepareLocalProxyRequestHeaders,
} from './prepare-local-proxy-request-headers.js';

export { methodAllowsRequestBody } from './prepare-local-proxy-request-headers.js';

export interface ProxyRequestLike {
  method: string;
  url: string;
  headers?: Record<string, string>;
  body?: string | ArrayBuffer | Uint8Array;
}

export interface BuiltLocalProxyHttpRequest {
  method: string;
  hostname: string;
  port: number;
  path: string;
  headers: Record<string, string>;
  sendingBody: boolean;
  body?: string | ArrayBuffer | Uint8Array;
}

const ALLOWED_HOSTS = new Set(['localhost', '127.0.0.1', '::1']);

function willSendLocalProxyBody(request: ProxyRequestLike): boolean {
  if (!methodAllowsRequestBody(request.method)) return false;
  return request.body !== undefined && request.body !== null;
}

export function buildLocalProxyHttpRequest(
  request: ProxyRequestLike,
): BuiltLocalProxyHttpRequest | { error: string } {
  let url: URL;
  try {
    url = new URL(request.url);
  } catch {
    return { error: `Invalid URL: ${request.url}` };
  }

  const hostname = url.hostname.replace(/^\[|\]$/g, '');
  if (!ALLOWED_HOSTS.has(url.hostname) && !ALLOWED_HOSTS.has(hostname)) {
    return { error: 'Only localhost requests are allowed' };
  }

  const sendingBody = willSendLocalProxyBody(request);
  const headers = prepareLocalProxyRequestHeaders(request.method, request.headers, sendingBody);
  headers.host = url.host;

  const isHttps = url.protocol === 'https:';
  const port = url.port ? Number(url.port) : isHttps ? 443 : 80;

  return {
    method: request.method,
    hostname: url.hostname,
    port,
    path: `${url.pathname}${url.search}`,
    headers,
    sendingBody,
    body: sendingBody ? request.body : undefined,
  };
}
